<template>
  <table class="plan-table" border="1">
    <tr>
      <th colspan="8">
        <a-space>
          <div>生产任务日期 {{ selectTime.product }}</div>
          <!-- <a-date-picker
            v-model:value="selectTime.product"
            @change="handleUpdateDateProduct"
          /> -->
        </a-space>
      </th>
      <th colspan="2">工序库存</th>
      <th>操作</th>
    </tr>

    <tr>
      <th>半成品</th>
      <th>型号</th>
      <th>批号</th>
      <th>生产任务</th>
      <th>当前完成数量</th>
      <th>当前送检数量</th>
      <th>当前合格数量</th>
      <th>当前完成率</th>
      <th>合格数量</th>
      <th>未检数量</th>
      <td rowspan="9">
        <a-button
          type="primary"
          size="mini"
          @click="saveProductTasks"
          :disabled="productTasksDisabled"
          >保存
        </a-button>
      </td>
    </tr>

    <tr>
      <td rowspan="2">完整参考臂</td>
      <!-- 型号 -->
      <td>swan 600</td>
      <!-- 批号 -->
      <td>
        <a-select
          allowClear
          :options="batchOption.swan600"
          placeholder="请选择批号"
          style="width: 200px"
          v-model:value="productTasks.completeReferenceArm.swan600.batch"
          :disabled="productTasksDisabled"
        >
        </a-select>
      </td>
      <!-- 生产任务 -->

      <template v-for="key in keyList" :key="key">
        <td>
          <template v-if="key === 'productionTaskNumber'">
            <a-input-number
              :step="1"
              v-model:value="productTasks.completeReferenceArm.swan600[key]"
              :disabled="productTasksDisabled"
              @change="
                getCurrentCompletedRate(
                  productTasks.completeReferenceArm.swan600
                )
              "
            ></a-input-number>
          </template>

          <template v-else-if="key === 'currentQualifiedNumber'">
            <a-input-number
              :step="1"
              v-model:value="productTasks.completeReferenceArm.swan600[key]"
              @change="
                getCurrentCompletedRate(
                  productTasks.completeReferenceArm.swan600
                )
              "
              :disabled="productTasksDisabled"
            ></a-input-number>
          </template>

          <template v-else-if="key === 'currentCompletedRate'">
            {{ productTasks.completeReferenceArm.swan600[key] }}%
          </template>

          <template v-else>
            <a-input-number
              :step="1"
              v-model:value="productTasks.completeReferenceArm.swan600[key]"
              :disabled="productTasksDisabled"
            ></a-input-number>
          </template>
        </td>
      </template>
    </tr>

    <tr>
      <!-- 型号 -->
      <td>swan 600P</td>
      <!-- 批号 -->
      <td>
        <a-select
          allowClear
          :options="batchOption.swan600P"
          placeholder="请选择批号"
          style="width: 200px"
          v-model:value="productTasks.completeReferenceArm.swan600P.batch"
          :disabled="productTasksDisabled"
        >
        </a-select>
      </td>
      <template v-for="key in keyList" :key="key">
        <td>
          <template v-if="key === 'productionTaskNumber'">
            <a-input-number
              :step="1"
              v-model:value="productTasks.completeReferenceArm.swan600P[key]"
              :disabled="productTasksDisabled"
              @change="
                getCurrentCompletedRate(
                  productTasks.completeReferenceArm.swan600P
                )
              "
            ></a-input-number>
          </template>

          <template v-else-if="key === 'currentQualifiedNumber'">
            <a-input-number
              :step="1"
              v-model:value="productTasks.completeReferenceArm.swan600P[key]"
              @change="
                getCurrentCompletedRate(
                  productTasks.completeReferenceArm.swan600P
                )
              "
              :disabled="productTasksDisabled"
            ></a-input-number>
          </template>

          <template v-else-if="key === 'currentCompletedRate'">
            {{ productTasks.completeReferenceArm.swan600P[key] }}%
          </template>

          <template v-else>
            <a-input-number
              :step="1"
              v-model:value="productTasks.completeReferenceArm.swan600P[key]"
              :disabled="productTasksDisabled"
            ></a-input-number>
          </template>
        </td>
      </template>
    </tr>
  </table>

  <table class="plan-table" border="1">
    <tr>
      <th colspan="8">
        <a-space>
          <div>返修任务日期 {{ selectTime.repair }}</div>
          <!-- <a-date-picker
            v-model:value="selectTime.repair"
            @change="handleUpdateDateRepair"
          /> -->
        </a-space>
      </th>

      <th rowspan="10">
        <a-button
          type="primary"
          @click="saveRepairTasks"
          :disabled="repairTasksDisabled"
          >保存</a-button
        >
      </th>
    </tr>

    <tr>
      <th>半成品</th>
      <th>型号</th>
      <th>批号</th>
      <th>返修任务</th>
      <th>当前完成数量</th>
      <th>当前送检数量</th>
      <th>当前合格数量</th>
      <th>当前完成率</th>
    </tr>

    <tr>
      <td rowspan="2">完整参考臂</td>
      <!-- 型号 -->
      <td>swan 600</td>
      <!-- 批号 -->
      <td>
        <a-input
          placeholder="请输入批号"
          v-model:value="repairTasks.completeReferenceArm.swan600.batch"
          :disabled="repairTasksDisabled"
        />
      </td>
      <!-- 生产任务 -->
      <template v-for="key in repairKey" :key="key">
        <td>
          <template v-if="key === 'repairTaskNumber'">
            <a-input-number
              :step="1"
              v-model:value="repairTasks.completeReferenceArm.swan600[key]"
              :disabled="repairTasksDisabled"
              @change="
                getCurrentCompletedRate(
                  repairTasks.completeReferenceArm.swan600
                )
              "
            ></a-input-number>
          </template>

          <template v-else-if="key === 'currentQualifiedNumber'">
            <a-input-number
              :step="1"
              v-model:value="repairTasks.completeReferenceArm.swan600[key]"
              @change="
                getCurrentCompletedRate(
                  repairTasks.completeReferenceArm.swan600
                )
              "
              :disabled="repairTasksDisabled"
            ></a-input-number>
          </template>

          <template v-else-if="key === 'currentCompletedRate'">
            {{ repairTasks.completeReferenceArm.swan600[key] }}%
          </template>

          <template v-else>
            <a-input-number
              :step="1"
              v-model:value="repairTasks.completeReferenceArm.swan600[key]"
              :disabled="repairTasksDisabled"
            ></a-input-number>
          </template>
        </td>
      </template>
    </tr>

    <tr>
      <!-- 型号 -->
      <td>swan 600P</td>
      <!-- 批号 -->
      <td>
        <a-input
          placeholder="请输入批号"
          v-model:value="repairTasks.completeReferenceArm.swan600P.batch"
          :disabled="repairTasksDisabled"
        />
      </td>
      <template v-for="key in repairKey" :key="key">
        <td>
          <template v-if="key === 'repairTaskNumber'">
            <a-input-number
              :step="1"
              v-model:value="repairTasks.completeReferenceArm.swan600P[key]"
              :disabled="repairTasksDisabled"
              @change="
                getCurrentCompletedRate(
                  repairTasks.completeReferenceArm.swan600P
                )
              "
            ></a-input-number>
          </template>

          <template v-else-if="key === 'currentQualifiedNumber'">
            <a-input-number
              :step="1"
              v-model:value="repairTasks.completeReferenceArm.swan600P[key]"
              @change="
                getCurrentCompletedRate(
                  repairTasks.completeReferenceArm.swan600P
                )
              "
              :disabled="repairTasksDisabled"
            ></a-input-number>
          </template>

          <template v-else-if="key === 'currentCompletedRate'">
            {{ repairTasks.completeReferenceArm.swan600P[key] }}%
          </template>

          <template v-else>
            <a-input-number
              :step="1"
              v-model:value="repairTasks.completeReferenceArm.swan600P[key]"
              :disabled="repairTasksDisabled"
            ></a-input-number>
          </template>
        </td>
      </template>
    </tr>
  </table>
</template>

<script>
import { computed, defineComponent, reactive, inject, watch } from "vue";
import { timeStampToTime, debounce, Toast } from "@/utils/index";
import {
  getBatch,
  saveOrUpdateProductionTask,
  getProductionTaskList,
  getRepairTaskList,
  saveOrUpdateRepairTask,
} from "@/request/view/product";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    semimanufactured: Object,
    editAuthority: Boolean,
  },
  setup(props) {
    const batchOption = reactive({
      swan600: [],
      swan600P: [],
    });

    const localDate = timeStampToTime("", "upload");

    const { id, username } = useStore().state.user.user;

    const selectTime = reactive({
      product: timeStampToTime("", "upload"),
      repair: timeStampToTime("", "upload"),
    });

    const productTasksDisabled = computed(() => {
      if (props.editAuthority) {
        return false;
      }
      return selectTime.product < localDate;
    });
    const repairTasksDisabled = computed(() => {
      if (props.editAuthority) {
        return false;
      }
      return selectTime.repair < localDate;
    });

    const getTasksItem = (type, project) => {
      return {
        batch: null,
        currentCompletedNumber: null,
        currentInspectionNumber: null,
        currentQualifiedNumber: null,
        currentCompletedRate: null,
        repairTaskNumber: null,
        id: null,
        inventoryNotInspectionNumber: null,
        localDate: timeStampToTime("", "upload"),
        productionTaskNumber: null,
        project,
        qualifiedInventoryNumber: null,
        type,
        userId: id,
        username: username,
      };
    };

    const productTasks = reactive({
      completeReferenceArm: {
        swan600: getTasksItem("completeReferenceArm", "swan 600"),
        swan600P: getTasksItem("completeReferenceArm", "swan 600P"),
      },
    });

    const repairTasks = reactive({
      completeReferenceArm: {
        swan600: getTasksItem("completeReferenceArm", "swan 600"),
        swan600P: getTasksItem("completeReferenceArm", "swan 600P"),
      },
    });

    const keyList = [
      "productionTaskNumber",
      "currentCompletedNumber",
      "currentInspectionNumber",
      "currentQualifiedNumber",
      "currentCompletedRate",
      "qualifiedInventoryNumber",
      "inventoryNotInspectionNumber",
    ];

    const componentsKeyList = [
      "productionTaskNumber",
      "currentCompletedNumber",
      "inventoryNotInspectionNumber",
    ];

    const repairKey = [
      "repairTaskNumber",
      "currentCompletedNumber",
      "currentInspectionNumber",
      "currentQualifiedNumber",
      "currentCompletedRate",
    ];

    const getBatchData = (list) => {
      list.forEach((project) => {
        getBatch({
          project,
        }).then((res) => {
          if (res.code === 200 && res.message === "成功") {
            const key = project.replace(/\s+/g, "");
            const {
              currentBatch,
              currentNumber,
              nextBatch,
              nextNumber,
              previousBatch,
            } = res.data;
            batchOption[key].push(
              {
                label: `上一批次${previousBatch}`,
                value: previousBatch,
              },
              {
                label: `当前批次${currentBatch}`,
                value: currentBatch,
              },
              {
                label: `下一批次${nextBatch}`,
                value: nextBatch,
              }
            );
          }
        });
      });
    };

    getBatchData(["swan 600", "swan 600P"]);

    const resetTaks = (target) => {
      const resetItem = (item) => {
        Object.keys(item.swan600).forEach((key) => {
          if (
            key === "type" ||
            key === "project" ||
            key === "userId" ||
            key === "username"
          ) {
            return;
          }
          if (key === "localDate") {
            item.swan600[key] = selectTime.product;
          } else {
            item.swan600[key] = null;
          }
        });
        Object.keys(item.swan600P).forEach((key) => {
          if (
            key === "type" ||
            key === "project" ||
            key === "userId" ||
            key === "username"
          ) {
            return;
          }
          if (key === "localDate") {
            item.swan600P[key] = selectTime.product;
          } else {
            item.swan600P[key] = null;
          }
        });
      };

      Object.keys(target).forEach((key) => {
        resetItem(target[key]);
      });
    };

    const getProductTasks = () => {
      resetTaks(productTasks);
      getProductionTaskList({
        localDate: selectTime.product,
        type: "completeReferenceArm",
      }).then((res) => {
        if (res.code === 200 && res.message === "成功") {
          Object.keys(res.data).forEach((key) => {
            const [swan600Item] = res.data[key].filter(
              (item) => item.project === "swan 600"
            );
            const [swan600PItem] = res.data[key].filter(
              (item) => item.project === "swan 600P"
            );

            Object.keys(productTasks[key].swan600).forEach((fild) => {
              productTasks[key].swan600[fild] = swan600Item[fild];
            });
            Object.keys(productTasks[key].swan600P).forEach((fild) => {
              productTasks[key].swan600P[fild] = swan600PItem[fild];
            });
          });
        }
      });
    };

    const getRepairTasks = () => {
      resetTaks(repairTasks);
      getRepairTaskList({
        localDate: selectTime.repair,
        type: "completeReferenceArm",
      }).then((res) => {
        if (res.code === 200 && res.message === "成功") {
          Object.keys(res.data).forEach((key) => {
            const [swan600Item] = res.data[key].filter(
              (item) => item.project === "swan 600"
            );
            const [swan600PItem] = res.data[key].filter(
              (item) => item.project === "swan 600P"
            );

            Object.keys(repairTasks[key].swan600).forEach((fild) => {
              repairTasks[key].swan600[fild] = swan600Item[fild];
            });
            Object.keys(repairTasks[key].swan600P).forEach((fild) => {
              repairTasks[key].swan600P[fild] = swan600PItem[fild];
            });
          });
        }
      });
    };

    const saveProductTasks = debounce(() => {
      const data = [];
      Object.keys(productTasks).forEach((key) => {
        data.push(productTasks[key].swan600);
        data.push(productTasks[key].swan600P);
      });

      saveOrUpdateProductionTask(data).then((res) => {
        let type = res.code === 200 ? "success" : "warning";
        Toast(type, res.message, 3);
        if (res.code === 200 && res.message === "成功") {
          res.data.forEach((item) => {
            const { type, project } = item;
            const machineType = project.replace(/\s+/g, "");
            productTasks[type][machineType].id = item.id;
          });
        }
      });
    }, 200);

    const saveRepairTasks = debounce(() => {
      const data = [];
      Object.keys(repairTasks).forEach((key) => {
        data.push(repairTasks[key].swan600);
        data.push(repairTasks[key].swan600P);
      });

      saveOrUpdateRepairTask(data).then((res) => {
        let type = res.code === 200 ? "success" : "warning";
        Toast(type, res.message, 3);
        if (res.code === 200 && res.message === "成功") {
          res.data.forEach((item) => {
            const { type, project } = item;
            const machineType = project.replace(/\s+/g, "");
            repairTasks[type][machineType].id = item.id;
          });
        }
      });
    }, 200);

    const getCurrentCompletedRate = (item) => {
      const taskNum = item.productionTaskNumber || item.repairTaskNumber;

      if (taskNum && item.currentQualifiedNumber) {
        item.currentCompletedRate = (
          (item.currentQualifiedNumber / taskNum) *
          100
        ).toFixed(2);
      }
    };

    getProductTasks();
    getRepairTasks();

    const handleUpdateDateProduct = (e, stringTime) => {
      selectTime.product = stringTime;
      getProductTasks();
    };
    const handleUpdateDateRepair = (e, stringTime) => {
      selectTime.repair = stringTime;
      getRepairTasks();
    };

    const cascadeDate = inject("cascadeDate", null);
    watch(
      () => cascadeDate,
      (val) => {
        if (!val.value) return;
        const date = val.value.format("YYYY-MM-DD");
        if (date !== selectTime.repair || date !== selectTime.product) {
          selectTime.product = date;
          selectTime.repair = date;
          getProductTasks();
          getRepairTasks();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      keyList,
      componentsKeyList,
      productTasks,
      batchOption,
      timeStampToTime,
      saveProductTasks,
      repairTasks,
      saveRepairTasks,
      repairKey,
      selectTime,
      localDate,
      getProductTasks,
      getRepairTasks,
      getRepairTaskList,
      handleUpdateDateRepair,
      handleUpdateDateProduct,
      getCurrentCompletedRate,
      productTasksDisabled,
      repairTasksDisabled,
    };
  },
});
</script>

<style lang="less" scoped>
.plan-table {
  margin: 30px auto;
  th,
  td {
    padding: 5px 10px;
    text-align: center;
  }
}
.tasks-title {
  width: 120px;
}
</style>
